module.exports = __webpack_public_path__ + "static/picture2-f4e5aacb19387515109755d672ec50cd.jpg";